/* global Search, searchArchiveWebinarsDataRaw, searchArchiveWebinarsData */
if (document.querySelector(".fbjs-search--webinars-events-archive")) {
    window.searchArchiveWebinarsDataRaw = [];
    window.searchArchiveWebinarsMonth = [];
    window.searchArchiveWebinarsData = {
        aditionalInfo: {
            resetData: 1,
            displayYear: 0,
        },

        webinars: {},
    };
}
const sortData = () => {
    const currentDate = new Date()
        .toISOString()
        .substring(0, 10)
        .replace(/-/gi, "");
    //const currentDate = '20190429';
    const currentYear = new Date().getFullYear();
    const Years = [currentYear];
    for (var i = 0; i < 100; i++) {
        Years.push(currentYear - (i + 1));
    }
    var exp = searchArchiveWebinarsDataRaw.filter(
        (el) => el.fbEndDate < currentDate
    );
    Years.map((el) => {
        searchArchiveWebinarsData.webinars[el] = exp.filter((item) => {
            if (item.eventYear == el) {
                searchArchiveWebinarsData.aditionalInfo.displayYear = 1;
                return true;
            } else {
                return false;
            }
        });
    });
};
const changeDate = (dateToChange) => {
    const monthArray = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ],
        splitedDate = dateToChange.split("-");

    return `${splitedDate[2]} ${
                        monthArray[Number(splitedDate[1]) - 1]
                    } ${splitedDate[0]}`;
};
const changeTwoDates = (firstDate, secondDate) => {
    const monthArray = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ],
        splitFirstDate = firstDate.split("-"),
        splitSecondDate = secondDate.split("-");

    return `${splitFirstDate[2]} - ${splitSecondDate[2]} ${
                        monthArray[Number(splitFirstDate[1]) - 1]
                    } ${splitFirstDate[0]}`;
};
const buildHtml = async () => {
    let output = '<div class="insights-webinars-events-listing__wrapper">';
    /**
     * @param eventURL
     * @param title
     * @param dateWrapper
     * @param eventImage
     * @param pageType
     * @param webinarSubheading
     * @param eventLocation
     * @param eventButtonText
     * @returns {string}
     **/
    const signleElementTemplate = (
        eventUrl,
        title,
        dateWrapper,
        eventImage,
        pageType,
        webinarSubheading,
        eventLocation
    ) => `<div class="col-4 col-md-6 col-sm-12 col-lg-4">
    <div class="webinars-wrapper">
        <article class="cards__card row no-gutters flex-column justify-content-between flex-wrap">
            <div class="cards__flag-wrapper">
                <div class="cards__flag-type">${dateWrapper}</div>
            </div>
            <div class="cards__image-wrapper">
                <div class="cards__image" style="
                        background-image: url(${eventImage});
                    "></div>
            </div>
            <div class="cards__content no-gutters flex-column justify-content-between">
                <div>
                    <div class="type">${pageType}</div>
                    <p class="title">${title}</p>
                    ${webinarSubheading}
                    ${eventLocation}
                </div>
                <div class="cards__links">
                <a href="https://wood-search01.squiz.co.uk${eventUrl}">Read more</a>
                </div>
            </div>
        </article>
    </div>
</div>`;

    /**
     *
     * @param {[]} array array with items
     * @param {string} heading
     * @returns  html
     */
    // const elementsWrapperTemplate = (array, heading) => {
    //     if (array.length) {
    //         let output = "";
    //         output += `<h5 class="webinars-header heading-mobile-centered">${heading}</h5><div class="cards cards-story"><div class="cards__wrapper col-mobile-centered results ">`;

    //         array.map((el) => {
    //             output += signleElementTemplate(
    //                 el.eventUrl,
    //                 el.title,
    //                 el.dateWrapper,
    //                 el.eventImage,
    //                 el.pageType,
    //                 el.webinarSubheading,
    //                 el.eventLocation,
    //                 el.eventButtonText
    //             );
    //         });

    //         output += `</div></div>`;
    //         return output;
    //     }
    // };
    await sortData();

    /**
     * display data
     */
    if (searchArchiveWebinarsData.aditionalInfo.displayYear) {
        const objKeys = Object.keys(searchArchiveWebinarsData.webinars);
        for (let i = 0; i < objKeys.length; i++) {
            if (searchArchiveWebinarsData.webinars[objKeys[i]].length) {
                output += `
                    <h5 class="webinars-header heading-mobile-centered">${objKeys[i]}</h5>
                    <div class="cards cards-story"><div class="cards__wrapper col-mobile-centered results">`;

                [...searchArchiveWebinarsData.webinars[objKeys[i]]].map(
                    (el) => {
                        output += signleElementTemplate(
                            el.eventUrl,
                            el.title,
                            el.dateWrapper,
                            el.eventImage,
                            el.pageType,
                            el.webinarSubheading,
                            el.eventLocation,
                            el.eventButtonText
                        );
                    }
                );
                output += `</div></div>`;
            }
        }
    }

    output += "</div>";

    //removing old output after raload data
    var contntWrapper = document.querySelector(
        "insights-webinars-events-listing__wrapper"
    );
    if (contntWrapper) {
        contntWrapper.parentNode.removeChild(contntWrapper);
    }

    //displaing output on front
    document.querySelector(".results-wrapper").innerHTML = output;
};

if (document.querySelector(".fbjs-search--webinars-events-archive")) {
    window.webinarsEventsArchive = new Search.default({
        url: "https://wood-search01.squiz.co.uk/s/search.json",
        collections: ["wood-data"],
        additionalFBparams: {
            profile: "_default",
            "f.pageType|pageType": "event - webinar",
        },
        onFiltersUpdate: () => {
            buildHtml();
            searchArchiveWebinarsData.aditionalInfo.resetData = 1;
        },
        beforeSearch: () => {
            if (searchArchiveWebinarsData.aditionalInfo.resetData) {
                searchArchiveWebinarsDataRaw = [];
                searchArchiveWebinarsData.webinars = {};
                searchArchiveWebinarsData.aditionalInfo.resetData = 0;
                searchArchiveWebinarsData.aditionalInfo.displayYear = 0;
            }
        },
        results: {
            numRanks: 100,
        },
        sort: {
            type: "metaeventYear",
        },
        activeFacets: {
            target: ".active-facets",
            // ... some other configuration fields
        },
        activeFacetsOnStart: {
            "f.pageType|pageType": [
                //         "expertise - software",
                //         "expertise - sme profile",
                //         "expertise - product",
                //         "expertise - expertise",
                //         "key market"
            ],
            "f.keyMarketEnergy|keyMarketEnergy": [],
            "f.keyMarketEnvironment|keyMarketEnvironment": [],
            "f.geographies|geographies": [],
        },

        pagination: {
            loadMore: false,
            arrows: false,
            arrowsOnEdgePages: false,
            dots: false,
            edgePages: false,
            pages: 0,
        },

        templates: {
            activeFacet: (name, param) => {
                const changeName = name
                    .replace(/_ampersand_/gi, "&")
                    .replace(/_comma_/gi, ",");
                return `
                  <span param="${param}" name="${name}">
                    ${changeName}
                  </span>
                `;
            },
            articleTemplate: (fields) => {
                const pageType = fields.metaData.pageType ?
                    fields.metaData.pageType.replace(/\w*\s-\s/gm, "") :
                    "";

                // 2017-08-10 -> 10 Aug 2017

                // const eventStartDate = fields.metaData.eventStartDate;
                const eventEndDate = fields.metaData.eventEndDate;
                const eventYear = fields.metaData.eventYear;
                const fbEndDate = fields.metaData.fbEndDate;
                const eventImage =
                    fields.metaData.eventImage || fields.metaData.webinarImage;
                const title = fields.metaData.t;
                const eventLocation = fields.metaData.eventLocation ?
                    `<div class="location-title">Location</div><p class="location">${fields.metaData.eventLocation}</p>` :
                    "";
                const eventButtonText =
                    fields.metaData.eventMoreInfoTitle ||
                    fields.metaData.webinarCTAText;
                const eventUrl = fields.clickTrackingUrl;

                const webinarSubheading = fields.metaData.webinarSubheading ?
                    `<p>${fields.metaData.webinarSubheading}</p>` :
                    ``;

                let dateWrapper = "";
                if (
                    fields.metaData.eventStartDate ===
                    fields.metaData.eventEndDate
                ) {
                    dateWrapper = changeDate(fields.metaData.eventStartDate);
                } else {
                    dateWrapper = `${changeTwoDates(
                        fields.metaData.eventStartDate,
                        fields.metaData.eventEndDate
                    )}`;
                }

                searchArchiveWebinarsDataRaw.push({
                    title: title,
                    pageType: pageType,
                    eventUrl: eventUrl,
                    dateWrapper: dateWrapper,
                    eventImage: eventImage,
                    webinarSubheading: webinarSubheading,
                    eventLocation: eventLocation,
                    eventEndDate: eventEndDate,
                    eventButtonText: eventButtonText,
                    eventYear: eventYear,
                    fbEndDate: fbEndDate,
                });

                return "";
                /*return `<div class="col-4 col-md-6 col-sm-12 col-lg-4">
                    <div class="webinars-wrapper">
                        <article class="cards__card row no-gutters flex-column justify-content-between flex-wrap">
                            <div class="cards__flag-wrapper">
                                <div class="cards__flag-type">${dateWrapper}</div>
                            </div>
                            <div class="cards__image-wrapper">
                                <div class="cards__image" style="
                                        background-image: url(${eventImage});
                                    "></div>
                            </div>
                            <div class="cards__content no-gutters flex-column justify-content-between">
                                <div>
                                    <div class="type">${pageType}</div>
                                    <p class="title">${title}</p>
                                    ${webinarSubheading}
                                    ${eventLocation}
                                </div>
                                <div class="cards__links">
                                    <a class="primary-link" href="${eventUrl}">${eventButtonText}</a>
                                </div>
                            </div>
                        </article>
                    </div>
                </div>`*/
            },
            /**
             * @name informationTemplate
             * @param fields
             * @param resultsSummary
             * @param h
             * @returns {string}
             **/
            informationTemplate: () => {
                return "";
            },
            formTemplate: (search, query, inputId) => {
                query == "!nullsearch" ? (query = "") : null;
                return `
                    <form class="search__form" role="search" action="/search" method="get">
                        <label for="${inputId}" class="sr-only">Search site</label>
                        <input
                            id="${inputId}"
                            type="text"
                            class="search__form-input search-custom"
                            placeholder="Webinars search"
                            autocomplete="off"
                            role="searchbox"
                            aria-label="Search"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            maxlength="1000"
                            aria-haspopup="menu"
                            aria-expanded="false"
                            value="${query}">
                        <button type="submit" name="site-search-submit" id="site-search-submit" class="search__submit">
                            <i class="search__submit-icon" aria-hidden="true"></i>
                            <span class="sr-only">Do search</span>
                        </button>
                        <div class="fb-search-wrapper"></div>
                    </form>
                `;
            },
            /**
             * @name paginationNumberTemplate
             * @param number
             * @param startrank
             * @returns {string}
             **/
            paginationNumberTemplate: () => {
                return ''; //<li class="hidden" data-startrank=${startrank} tabindex="0" >${number}</li>
            },
            /**
             * @name activePaginationNumberTemplate
             * @param number
             * @returns {string}
             **/
            activePaginationNumberTemplate: () => {
                return ''; //<li class="search__active-page hidden">${number}</li>
            },
            /**
             * @name paginationTemplate
             * @param pages
             * @returns {string}
             **/
            paginationTemplate: (pages) => {
                return `<div class="search__pagination">${pages}</div>`;
            },
            /**
             * @name loadMoreTemplate
             * @param fields
             * @returns {string}
             **/
            loadMoreTemplate: () => {
                return '<div class="landing-page__button-wrapper"><button id="search-loadmore" type="button" title="Load more results" class="btn btn--secondary">Load more</button></div>';
            },

            facetCheckbox: ({
                categories,
                singleChoice
            }, activeFacets, h) => {
                //{name, label}, activeFacets
                // const header = label ? `<div>${label}</div>` : `<div>${name}</div>`;
                let list = "";
                list +=
                    '<li class="search__facet-item search__facet-item--all"></li>';

                categories[0].values.forEach((item) => {
                    if (item.label !== "other") {
                        list += `<li class="search__facet-item">
                                <label class="search__facet-label">
                                    <input
                                    class="search__facet-input"
                                    type="checkbox"
                                    ${item.checked}
                                    value="${item.data}"
                                    name="${item.label}"
                                    data-fparam="${h.queryStringParamName}"
                                    data-singlechoice="${singleChoice}"
                                    />
                                    <span class="search__facet-span">${item.label}</span>
                                </label>
                                </li>`;
                    }
                });

                return `<div class="checkbox-facet">
                        <ul class="search__facets">
                        ${list}
                        </ul>
                    </div>`;
            },
            /**
             * @name noResults
             * @param query
             * @param spell
             * @returns {string}
             **/
            noResults: () => {
                // let spellSuggestion = "";
                // if (spell.text) {
                //     spellSuggestion = `<div>Did you mean: <a href="?${spell.url}">${spell.text}</a>?</div>`;
                // }
                return "<div>We're sorry, we couldn't find anything matching .</div>";
            },
        },
    });

    window.webinarsEventsArchive.init();
}
